import React from "react";
import { Box, Button, Checkbox, ButtonBase } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import SkillSheetMainSummaryDesktop from "../../../../mypage/SkillSheetMainSection/SkillSheetMainSummaryTable/SkillSheetMainSummaryDesktop";
import SkillSheetMainSummaryMobile from "../../../../mypage/SkillSheetMainSection/SkillSheetMainSummaryTable/SkillSheetMainSummaryMobile";
import { buildWorkHistoryDisplayValues } from "../../../../mypage/SkillSheetMainSection/SkillSheetMainSummaryTable/buildWorkHistoryDisplayValues";
import { GRAY_COLOR_DARK } from "../../../../../constants/colors";

/**
 * 1プロジェクト分の表示
 * チェック・解除ボタンなどの操作もここで行う
 */
export default function ProjectSummaryItem({
  group,
  workHistory,
  phases,
  checked,
  isGrouped,
  processing,
  onToggleSelected,
  onRemoveFromGroup,
  isDesktop,
}) {
  const displayValues = buildWorkHistoryDisplayValues(workHistory);

  return (
    <Box>
      {/* チェックボックス + サマリー */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        {/* PCだけチェックボックス表示 */}
        {isDesktop && (
          <Checkbox
            size="small"
            checked={checked}
            onChange={() => onToggleSelected(workHistory.id)}
            sx={{
              flexShrink: 0,
              transform: "scale(0.9)",
              p: 0.5,
            }}
          />
        )}

        {isDesktop ? (
          <Box sx={{ flex: 1 }}>
            <SkillSheetMainSummaryDesktop
              workHistory={workHistory}
              displayValues={displayValues}
              phases={phases}
            />
          </Box>
        ) : (
          <ButtonBase
            component="div"
            onClick={() => onToggleSelected(workHistory.id)}
            sx={{
              flex: 1,
              display: "block",
              textAlign: "left",
              cursor: "pointer",
              borderRadius: 2,
              outline: checked ? "2px solid #1976d2" : "none",
              outlineOffset: 2,
              width: "100%",

              "&.Mui-focusVisible": {
                outline: "2px solid #1976d2",
                outlineOffset: 2,
              },
            }}
          >
            <SkillSheetMainSummaryMobile
              workHistory={workHistory}
              displayValues={displayValues}
              phases={phases}
            />
          </ButtonBase>
        )}
      </Box>

      {/* グループから外すボタン */}
      {isGrouped && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            size="small"
            variant="text"
            startIcon={<ArrowCircleUpIcon />}
            onClick={() =>
              onRemoveFromGroup?.({
                groupId: group.groupId,
                workHistoryId: workHistory.id,
              })
            }
            disabled={processing}
            sx={{
              color: GRAY_COLOR_DARK,
              fontWeight: 700,

              "&:hover": {
                bgcolor: alpha(GRAY_COLOR_DARK, 0.08),
              },
            }}
          >
            このプロジェクトを外す
          </Button>
        </Box>
      )}
    </Box>
  );
}
